import { VF_SUB_SECTION_TITLE } from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';

const fieldId = 'sst-approver-group-names';

const validator = () => null;
// Changed the Add Approvers title to 'Add Business and Technical Approvers'
const vFParams = {
  fieldTitle: 'Add Business and Technical Approvers (optional)',
};

const sstApproverGroupNames = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_SUB_SECTION_TITLE,
};

export { sstApproverGroupNames };
